import Client from './Client'
import { Error } from './Error'

export default class User extends Client {

  async signUp(identifier, password) {
    try {
      return await this.request(null, 'post', 'auth/local/register', { identifier, password }, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async login(identifier: string, password: string ) {
    try {
      return await this.request(null, 'post', 'auth/local', { identifier, password }, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async updateLang(token, lang: string) {
    return await this.request(token, 'post', 'profil', { lang }, null)
  }

  async updatePhoneNumber(token, phoneNumber) {
    try {
      return await this.request(token, 'post', 'auth/cell', { cell: phoneNumber }, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async checkPhoneNumber(token, pin) {
    try {
      return await this.request(token, 'post', 'auth/cell/verification', { pin }, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async updateInformations(token, payload) {
    try {
      const params = {
        first_name: payload.firstName,
        last_name: payload.lastName,
        company: payload.company
      }
      return await this.request(token, 'post', 'profil', params, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async updatePassword(token, payload) {
    try {
      const params = {
        old: payload.currentPassword,
        new: payload.newPassword
      }
      return await this.request(token, 'post', 'auth/local/changepassword', params, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async lostPassword(email) {
    try {
      return await this.request(null, 'post', 'loosepassword', { email }, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async updateAvatar(token, base64) {
    try {
      return await this.request(token, 'post', 'profil/image', { data: base64 }, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async getRights(token) {
    try {
      return await this.request(token, 'get', 'right', null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async getAppSms(token, cell) {
    try {
      return await this.request(token, 'post', 'cta/text', { cell }, null)
    } catch (error) {
      throw new Error(error)
    }
  }
}
